import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../common/Navbar';
import Sidebar from '../common/Sidebar';
import { useAuth } from '../../context/AuthContext';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
    const isLocationcontain = location.pathname.includes('dashboard')
  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };
  // Staff/Progress/Management
  const adminNavItems = [
    { label: 'Dashboard', path: '/admin/dashboard', icon: <i className="bi bi-house-door"></i> },
    { label: 'Staff Management', path: '/admin/staff', icon: <i className="bi bi-people"></i> },
    { label: 'Course Management', path: '/admin/courses', icon: <i className="bi bi-book"></i> },
    { label: 'Manager Management', path: '/admin/managers', icon: <i className="bi bi-person-check"></i> },
    { label: 'Feeds', path: '/admin/feeds', icon: <i className="bi bi-rss"></i> },
    { label: 'Policy Management', path: '/admin/policy', icon: <i className="bi bi-shield-lock"></i> },
    { label: 'Profile', path: '/admin/profile', icon: <i className="bi bi-person"></i> },
];
  console.log("user",user)
  return (
    <div className="staff-layout d-flex">
    {/* Sidebar always on the left, full height */}
    <Sidebar navItems={adminNavItems} onLogout={handleLogout}/>
  
    {/* Right side: content area (navbar + main content) */}
    <div className="content-wrapper flex-grow-1 d-flex flex-column">
        {
      isLocationcontain &&
      <Navbar 
        username={user?.fullName}
        userRole={user?.role}
        onLogout={handleLogout}
      />
        }
      <main className="main-content flex-grow-1" style={{backgroundColor:'#F5F5FD'}}>
        <Outlet />
      </main>
    </div>
  </div>
   
  );
};

export default AdminLayout;